import {
  animate,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const layoutCoreSplashscreenAnimation = trigger(
  'layoutCoreSplashscreenAnimation',
  [
    transition('* => splashscreenCloseMobile', [
      style({ overflow: 'hidden' }),
      query(
        '.my-layout-splashscreen-wrapper',
        animate(
          '1.8s 0.6s ease-out',
          style({ position: 'absolute', top: '-2000px' }),
        ),
      ),
    ]),
    transition('* => splashscreenCloseDesktop', [
      query(
        '.my-layout-splashscreen-wrapper',
        animate('0.4s 0.6s', style({ opacity: 0 })),
      ),
    ]),
  ],
);

export const layoutCoreSplashscreenLogoAnimation = trigger(
  'layoutCoreSplashscreenLogoAnimation',
  [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('1s ease-out', style({ opacity: 1 })),
    ]),
  ],
);
